// @flow
import React from 'react';
import classNames from 'classnames';

import styles from './ECartItemThumb.module.scss';;


type Props = {
  imgSrc: string,
  title?: string,
  className?: string,
  htmlFor?: string,
}

const ECartItemThumb = ({ imgSrc, title, className, htmlFor }: Props) => (
  <div className={classNames(styles.root, className)}>
    <img src={imgSrc} alt={title} />
    {htmlFor
      && <label // eslint-disable-line jsx-a11y/label-has-associated-control
        className={styles.label}
        htmlFor={htmlFor}
      />}
  </div>
);

export default ECartItemThumb;
